import {createFileRoute} from "@tanstack/react-router";
import {throwRedirectToWorkspaceConfigEntry} from "~/utilities/workspaceHomeRoute";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/")({
    beforeLoad: ({context}) => {
        throwRedirectToWorkspaceConfigEntry(context.workspace.id, context.currentWorkspaceUser.templateId);
    },
});
